import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class HrBill {
  /* 账单列表 */
  static getHrBillList(option) {
    let url = `/oa/api/hr/payment/bill/list?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 账单详情 */
  static getDetails(option) {
    let url = `/oa/api/hr/payment/bill/detail?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 员工薪资列表 */
  static getSalaryList(option) {
    let url = `/oa/api/hr/payment/bill/list/worker/salary?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 账单核实 */
  static postVerify(data) {
    const url = `/oa/api/hr/payment/bill/check`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 导出账单 */
  static getExport(data) {
    let url = `/oa/api/download/hr/payment/bill?`;
    url += handleGetRequestParams(data)
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
}

export default HrBill;